import React from "react";

export function ChartActionButtons(props) {
    return <div className="mt-4 ml-2 flex justify-center">
        <button
            className="w-auto px-2 py-2 rounded-lg border text-white shadow bg-primaryColor"
            onClick={props.onClick}
        >
            Add Notifications
        </button>
        <button
            onClick={props.onClick1}
            className="bg-primaryColor text-white rounded-lg px-2 py-1 ml-2 "
        >
            Save Chart
        </button>
    </div>;
}